import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import App from '../App';

const LoginScreen = React.lazy(() => import('../components/LoginScreen').then(m => ({ default: m.LoginScreen })));
const SignUpScreen = React.lazy(() => import('../components/SignUpScreen').then(m => ({ default: m.SignUpScreen })));

export const AppRouter: React.FC = () => {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-gray-900 text-slate-600 dark:text-gray-300">Loading...</div>}>
        <Routes>
          {/* Main App handles its own auth routing natively in this refactor step to avoid breaking existing deep state bindings, but we wrap it in BrowserRouter so we can use hooks inside. */}
          <Route path="/*" element={<App />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
